
export default {
  vessel: {
    icon: {
      color: 'primary',
      fontSize: '2xl',
      marginBottom: 'sm'
    },
    title: {
      fontSize: 'lg',
      fontWeight: 'semibold'
    },
    wrapper: {
      zIndex: 10,
      overflow: 'hidden'
    },
    tabs: {
      overflowX: 'auto'
    },
    tab: {
      fontSize: 'md',
      fontWeight: 'semibold',
      paddingX: 'sm',
      paddingY: 'sm',
      cursor: 'pointer',
      borderBottomWidth: 2,
      whiteSpace: 'no-wrap',
      lg: {
        paddingX: 'md'
      }
    },
    tabContent: {
      paddingTop: 'xl'
    }
  },
  data() {
    return {
      activeTab: null,
      categories: null,
      groups: null
    }
  },
  async fetch() {
    const { $content, $i18n: { locale } } = this

    this.categories = await $content(locale, 'shop/features/categories')
      .sortBy('slug')
      .fetch()

    this.fetchFeatures()
  },
  methods: {
    onClick(category) {
      this.activeTab = category
    },
    async fetchFeatures() {
      if (!this.categories) return []

      const { $content, $i18n: { locale } } = this
      const groups = []

      this.categories.forEach(async ({ name }) => {
        const features = await $content(locale, 'shop/features')
          .where({ category: name })
          .sortBy('createdAt')
          .fetch()

        groups.push({ category: name, features })
      })

      this.activeTab = this.categories[0].name
      this.groups = groups
    }
  }
}
